import {
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { AppProvider } from '@toolpad/core/AppProvider';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { NAVIGATION } from '../DashboardPage/navigation';
import logo from 'assets/new/textLogo.png';
import { Header } from 'components/common/Header/Header';
import { useMediaQuery, useTheme } from '@mui/material';
import SidebarFooter from 'components/common/SidebarFooter/SidebarFooter';
import { DOCTOR_NAVIGATION } from '../DoctorDashboardPage/doctorNavigation';


export default function DoctorMainPage() {
  const location = useLocation();
  const navigateRR = useNavigate();
  const [searchParams] = useSearchParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const goHome = () => {
    navigateRR('/dashboard')
  }

  return (
    <AppProvider
      navigation={DOCTOR_NAVIGATION}
      router={{
        pathname: location.pathname,
        searchParams,
        navigate: (url) => {
          navigateRR(typeof url === 'string' ? url : url.pathname);
        },
      }}
      branding={{
        logo: (
          <img
            src={logo}
            alt="Casez"
            style={{ height: 32 }}
            onClick={goHome}
          />
        ),
        title: ''
      }}
      theme={theme}
    >
      <DashboardLayout
        slots={{
          toolbarActions: isMobile ? undefined : Header,
          sidebarFooter: SidebarFooter,
        }}
        sx={{
          '& a:hover, & button:hover': {
            color: 'inherit',
          },
        }}>
        <Outlet />
      </DashboardLayout>
    </AppProvider>
  );
}
